/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Q_Urun_EslestirmeInputs */

const tr_faq_q_urun_eslestirme = /** @type {(inputs: Faq_Q_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün eşleştirmesi nasıl yapılır?`)
};

const en_faq_q_urun_eslestirme = /** @type {(inputs: Faq_Q_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does product linking work?`)
};

const de_faq_q_urun_eslestirme = /** @type {(inputs: Faq_Q_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie funktioniert die Produktverknüpfung?`)
};

const ru_faq_q_urun_eslestirme = /** @type {(inputs: Faq_Q_Urun_EslestirmeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Как работает привязка товаров?`)
};

/**
* | output |
* | --- |
* | "How does product linking work?" |
*
* @param {Faq_Q_Urun_EslestirmeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const faq_q_urun_eslestirme = /** @type {((inputs?: Faq_Q_Urun_EslestirmeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Q_Urun_EslestirmeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_faq_q_urun_eslestirme(inputs)
	if (locale === "de") return de_faq_q_urun_eslestirme(inputs)
	if (locale === "ru") return ru_faq_q_urun_eslestirme(inputs)
	return tr_faq_q_urun_eslestirme(inputs)
});